import React from "react";
import { connect } from "react-redux";
import _ from "lodash";

@connect( store => {
    return {
        conversations: store.conversations,
        loggedUser: store.loggedUser
    }
})

class RemoveMember extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { dispatch, conversations,loggedUser } = this.props;

        const handleClose = () => {
            $( "#removeMember" ).modal( "hide" );
        }

        const handleDelete = () => {
            dispatch({ type: "UPDATE_CONVERSATIONS_SELECTED_ONLY", selected: { ...conversations.selected, tagged_users: conversations.selected.tagged_users.map( user => {
                if( this.props.deleteID === user.user.id ) {
                    return {
                        ...user,
                        isRemoved: true,
                        isArchived: this.props.deleteAction === "archived" ? true : false
                    };
                }

                return user;
            }),
            ...((loggedUser.data.id === this.props.deleteID) ? { isLeave: true, softUpdate: true } : {} )
        }});

            handleClose();
        }
        
        return (
            <div class="modal fade delete-modal bg-overlay" id="removeMember">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="row">
                                <div class="col-lg-10 col-md-10 col-sm-10">
                                    <p class="text-size18 text-black text-semi-bold mb0">
                                        { this.props.deleteAction !== "archived" && (this.props.deleteAction !== "me" ? "Remove User from Conversation?" : "Leave Conversation?") }
                                        { this.props.deleteAction === "archived" && "Archive this Conversation?" }
                                    </p>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-2">
                                    <a class="text-right text-black" aria-label="Close" onClick={ handleClose }>
                                        <i class="material-icons text-black text-size22">close</i>
                                    </a>
                                </div>
                            </div>    
                        </div>
                        <div class="modal-body">
                            <p class="m0 text-black">
                                { this.props.deleteAction !== "archived" && (this.props.deleteAction !== "me" ? "This will remove the user’s access to this conversation. Do you wish to proceed?" : "Once you leave, you will no longer have access to this conversation. Do you wish to proceed?") }
                                { this.props.deleteAction === "archived" && "Do you wish to proceed?" }
                            </p>
                        </div>
                        <div class="modal-footer">
                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-sm-4">
                                    <button type="button" class="btn btn-cancel text-black ml0" onClick={ handleClose }>Cancel</button>
                                </div>
                                <div class="col-lg-8 col-md-8 col-sm-8 text-align-right">
                                    <button type="button" class="btn btn-danger btn-delete" onClick={ handleDelete }>
                                        { this.props.deleteAction !== "archived" && (this.props.deleteAction !== "me" ? "Remove" : "Leave") }
                                        { this.props.deleteAction === "archived" && "Archive" }
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default RemoveMember;
